'use client';

import { c as _c } from "react/compiler-runtime";
import { z } from '@repo/schema';
import type { ResponsiveSheetPresentation } from '@repo/ui/components';
import { createContext, PropsWithChildren, use, useState } from 'react';
import { CreateCompanySchema } from './schema';
import { CreateCompanySheet } from '@/app/@protected/loads/new/_components/create-company/sheet.tsx';
export type OpenCreateCompanySheetOptions = {
  allowedTypes?: readonly CreatedCompany['type'][];
  defaultType?: CreatedCompany['type'];
  inheritedOrganisationId?: number;
  initialValues?: Partial<z.input<typeof CreateCompanySchema>>;
  onCreated?: (company: CreatedCompany) => void;
  orgIdOverride?: number;
  presentation?: ResponsiveSheetPresentation;
  source?: string;
};
type Context = {
  closeCreateCompanySheet: () => void;
  formKey: number;
  isOpen: boolean;
  openCreateCompanySheet: (options?: OpenCreateCompanySheetOptions) => void;
  options: null | OpenCreateCompanySheetOptions;
};
type CreatedCompany = {
  id: number;
  title: string;
  type: 'broker' | 'haulier' | 'shipper';
};
const CreateCompanySheetContext = createContext<Context | null>(null);
export const CreateCompanySheetProvider = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const [formKey, setFormKey] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsOpen(false);
      setOptions(null);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeCreateCompanySheet = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = nextOptions => {
      setOptions(nextOptions ?? null);
      setFormKey(_temp);
      setIsOpen(true);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const openCreateCompanySheet = t2;
  let t3;
  if ($[2] !== formKey || $[3] !== isOpen || $[4] !== options) {
    t3 = {
      closeCreateCompanySheet,
      formKey,
      isOpen,
      openCreateCompanySheet,
      options
    };
    $[2] = formKey;
    $[3] = isOpen;
    $[4] = options;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CreateCompanySheet data-sentry-element="CreateCompanySheet" data-sentry-source-file="context.tsx" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t3) {
    t5 = <CreateCompanySheetContext.Provider value={t3} data-sentry-element="CreateCompanySheetContext.Provider" data-sentry-component="CreateCompanySheetProvider" data-sentry-source-file="context.tsx">{children}{t4}</CreateCompanySheetContext.Provider>;
    $[7] = children;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export const useCreateCompanySheet = () => {
  const context = use(CreateCompanySheetContext);
  if (!context) {
    throw new Error('useCreateCompanySheet must be used within a CreateCompanySheetProvider');
  }
  return context;
};
function _temp(currentValue) {
  return currentValue + 1;
}